import React from "react";
import { Phone, MessageCircle } from "lucide-react";

export default function FloatingActions({ site }) {
  const phone = (site?.phone || "+919328797924").replace(/[^\d+]/g, "");
  const wa = (site?.whatsapp || phone).replace(/[^\d]/g, "");
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/${wa}?text=${encodeURIComponent("Hello Akashji, I'd like an inquiry from Shree Balaji Caterers.")}`}
        target="_blank" rel="noreferrer"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
        data-testid="whatsapp-floating-btn"
      >
        <MessageCircle size={24} />
      </a>
      <a
        href={`tel:${phone}`}
        className="w-14 h-14 rounded-full bg-gold text-navy-900 flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
        data-testid="call-floating-btn"
      >
        <Phone size={22} />
      </a>
    </div>
  );
}
